import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsBufferHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Buffer;
    }
}

//# sourceMappingURL=IsBufferHelper.js.map
